module.exports = __webpack_public_path__ + "img/Bedroom.06107647.jpg";